<!-- @format -->

<ng-container *transloco="let t">
  <fudis-dialog [size]="'xl'">
    <fudis-dialog-content>
      <div class="course-unit-info-modal">
        <app-student-course-unit-info-modal-header
          [courseUnit]="courseUnit"
          [validatablePlan]="currentSavedValidatablePlan"
          (setModalCourseUnitVersion)="setModalCourseUnitVersion($event)"
          (saveCourseUnitVersionChange)="saveCourseUnitVersionChange()"
          [allowEdit]="allowEdit"
          (selectTab)="selectedTab$.next($event)">
        </app-student-course-unit-info-modal-header>
        <div class="modal-body">
          @if (selectedTab$ | async; as selectedTab) {
            @switch (selectedTab) {
              @case ("BASIC") {
                <h3 class="sis-mt-zero ng-binding">{{ t("COURSE_UNIT_INFO_MODAL.TAB_HEADINGS.INFO") }}</h3>
                <app-course-unit-info-brochure
                  [courseUnit]="courseUnit"
                  [level]="4"
                  [sortedByNameResponsibilityInfos]="filteredResponsibilityInfos" />
              }
              @case ("SUBSTITUTIONS") {
                <h3 class="sis-mt-zero ng-binding">{{ t("COURSE_UNIT_INFO_MODAL.TAB_HEADINGS.SUBSTITUTIONS") }}</h3>
                <app-course-unit-info-modal-substitutions
                  [allowEdit]="allowEdit"
                  [showCrossStudySubstitutes]="true"
                  [courseUnit]="courseUnit"
                  [plan]="validatablePlan.plan"
                  [validatablePlan]="validatablePlan"
                  [studyRight]="studyRight"
                  [versionChangeInProgress]="versionChangeInProgress"
                  [currentUniversityOrgId]="currentUniversityOrgId"
                  [openSubstitutionForm]="openSubstitutionForm"
                  [openApplication]="openApplication"
                  (openCourseUnitModal)="openCourseUnitInfoModal($event)"
                  (selectSubstitutions)="selectSubstitutions($event)"
                  (removeSubstitutions)="removeSubstitutions($event)" />
              }
            }
          }
        </div>
      </div>
    </fudis-dialog-content>
  </fudis-dialog>
</ng-container>
